import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function InvitePage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [pw, setPw] = useState({ a: "", b: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/team/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setErr(formatApiError(e))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return toast.error("Passwords don't match");
    setBusy(true);
    try { await api.post("/team/accept", { token, password: pw.a }); toast.success("Account created — sign in to continue"); nav("/login"); }
    catch (e2) { toast.error(formatApiError(e2)); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-md mx-auto px-5 pt-36 pb-24" data-testid="invite-page">
      <p className="eyebrow">Team invite</p>
      {err && <p data-testid="invite-error" className="mt-6 text-rose-300">{err}</p>}
      {info && (
        <form onSubmit={submit} className="mt-6 space-y-4">
          <h1 className="font-display text-4xl">Welcome, {info.name}</h1>
          <p data-testid="invite-role" className="text-sm text-slate-400">You're joining as <b>{info.title}</b> ({info.email}). Choose a password with at least 12 characters. You'll confirm each sign-in with a code sent to your email.</p>
          <input data-testid="invite-password" type="password" minLength={12} required value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} placeholder="New password" className="lux-input" />
          <input data-testid="invite-password-confirm" type="password" minLength={12} required value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} placeholder="Confirm password" className="lux-input" />
          <button data-testid="invite-submit-btn" disabled={busy} className="btn-gold w-full py-3">Create my account</button>
        </form>
      )}
    </div>
  );
}
